import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Real merchandise images
const MERCH_ITEMS = [
  {
    name: "Tees",
    image: "https://customer-assets.emergentagent.com/job_d552568b-11a7-4297-a95d-747b937be8f2/artifacts/3i9ie69w_Subheading.png",
  },
  {
    name: "Sweatshirts",
    image: "https://customer-assets.emergentagent.com/job_d552568b-11a7-4297-a95d-747b937be8f2/artifacts/57uvi4ry_Subheading.jpeg",
  },
  {
    name: "Drinkware",
    image: "https://customer-assets.emergentagent.com/job_d552568b-11a7-4297-a95d-747b937be8f2/artifacts/m9ray3uf_Subheading.jpeg",
  },
  {
    name: "Accessories",
    image: "https://customer-assets.emergentagent.com/job_d552568b-11a7-4297-a95d-747b937be8f2/artifacts/uu9n0zbg_Subheading.jpeg",
  },
];

const MerchCollabSection = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address");
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${API}/api/merch/signup`, { email });
      toast.success(response.data.message);
      setEmail("");
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="mt-8 animate-fade-in">
      <Card className="bg-gradient-to-r from-amber-500/5 via-rose-500/5 to-purple-500/5 border-amber-500/20 overflow-hidden relative">
        <CardContent className="p-5">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-amber-500 via-rose-500 to-purple-500 flex items-center justify-center shadow-lg">
                <Sparkles className="h-4 w-4 text-white" />
              </div>
              <div>
                <h3 className="text-base font-bold text-primary">Rooted Wellness × House of Racha</h3>
                <p className="text-[10px] text-muted-foreground">Exclusive Collaboration</p>
              </div>
            </div>
            <span className="self-start sm:self-auto bg-gradient-to-r from-amber-500 to-rose-500 text-white text-[10px] font-semibold px-3 py-1 rounded-full shadow-md">
              Coming Soon
            </span>
          </div>
          
          {/* Hype Text */}
          <p className="text-xs text-muted-foreground text-center mb-4">
            Apparel & accessories designed with intention — 
            <span className="text-primary font-medium"> wear your wellness journey.</span>
          </p>

          {/* Product Image Grid */}
          <div className="grid grid-cols-4 gap-2 mb-4">
            {MERCH_ITEMS.map((item) => (
              <div key={item.name} className="relative group">
                <div className="aspect-square rounded-lg overflow-hidden border border-amber-500/20 bg-stone-100 dark:bg-stone-800">
                  <img 
                    src={item.image} 
                    alt={item.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <p className="text-[9px] text-center text-muted-foreground mt-1 font-medium">{item.name}</p>
              </div>
            ))}
          </div>

          {/* Signup */}
          <div className="flex flex-col sm:flex-row gap-2 max-w-sm mx-auto">
            <Input 
              type="email" 
              placeholder="Enter your email..." 
              className="flex-1 text-xs h-8"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="merch-collab-email"
            />
            <Button 
              size="sm" 
              className="h-8 text-xs rounded-full bg-gradient-to-r from-amber-500 to-rose-500 hover:from-amber-600 hover:to-rose-600 text-white"
              onClick={handleSubmit}
              disabled={isSubmitting}
              data-testid="merch-collab-notify"
            >
              {isSubmitting ? "..." : "Notify Me"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default MerchCollabSection;
